const KG_TO_LBS = 2.20462;
const LBS_TO_KG = 0.453592;

const CM_TO_INCHES = 0.393701;
const INCHES_TO_CM = 2.54;

export const cmToFeetInches = (cm: number): string => {
  const totalInches = Math.round(cm * CM_TO_INCHES);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return `${feet}'${inches}`;
};

export const feetInchesToCm = (feetInches: string): number | null => {
  const match = feetInches.match(/^(\d)'(\d{1,2})$/);
  if (!match) return null;

  const feet = Number.parseInt(match[1], 10);
  const inches = Number.parseInt(match[2], 10);
  const totalInches = feet * 12 + inches;
  return Math.round(totalInches * INCHES_TO_CM);
};

export const kgToLbs = (kg: number): number => Math.round(kg * KG_TO_LBS);
export const lbsToKg = (lbs: number): number => Math.round(lbs * LBS_TO_KG);
